import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { jswOnboardingResource } from '@atlassian/jira-router-resources-jsw-onboarding/src/index.tsx';
import { themePreferenceResource } from '@atlassian/jira-router-resources-theme-preference/src/controllers/resource-erai-1615-old/index.tsx';
import { softwareOnboardingRoute } from '@atlassian/jira-router-routes-software-onboarding-routes/src/softwareOnboardingRoute.tsx';
import { projectCreatePermissionsResource } from '@atlassian/jira-router-resources-project-permissions/src/services/project-permissions/index.tsx';

import { SoftwareOnboardingPage, LazySoftwareOnboardingPage } from './ui/index.tsx';

export const softwareOnboardingRouteEntry = createEntry(softwareOnboardingRoute, () => ({
	group: 'software',
	component: SoftwareOnboardingPage,
	layout: chromelessLayout,

	resources: [jswOnboardingResource, themePreferenceResource, projectCreatePermissionsResource],

	forPaint: [LazySoftwareOnboardingPage],
	canTransitionIn: () => false,

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-software-onboarding-entries/src/softwareOnboardingRouteEntry.tsx',
			whichExportToUse: 'softwareOnboardingRouteEntry',
		},

		enabled: true,
	},
}));
